export const decisionSummaryMap = {
    "As Certified": "Approved",
    "Mixed Decision": "Some Approved / Some Denied",
    "Pending Certification": "Pending",
    "Time Available": "Pending",
    "Waiting Period": "Pending",
    Denied: "Denied",
    Approved: "Approved",
    Pending: "Pending",
};
export const PAYMENT_COMPONENT_IDS = {
    pc401kDeferral: ["401K Deferral"],
    accidentalDeathDismemberment: ["Accidental Death & Dismemberment", "ADD"],
    preTaxLTC: ["PRELTC"],
    postTaxLTC: ["LTC", "Post Tax Long Term Care Premium"],
    preTaxDental: [
        "Pre Tax Dental",
        "PREDEN",
        "Pre Tax Primary Dental Premium",
    ],
    postTaxCancer: [
        "Post-tax Cancer",
        "Cancer plan/Critical Illness",
        "CANPLN",
        "Post-Tax Cancer Plan",
    ],
    retirement: ["Retirement"],
    preTaxFlexSpenDaycare: ["Pre Tax Flex Spen Daycare", "PREFDC"],
    healthSavingsAccount: ["Health Savings Account", "HLTHSA"],
    groupSupplementalEmployeeLife: [
        "Group Supplemental Employee Life",
        "GSELIF",
    ],
    preTaxGroupSuppDependentLife: [
        "Pre Tax Group Supp Dependent Life",
        "PREGDL",
    ],
    preTaxFlexSpenHealthcare: ["Pre Tax Flex Spen Healthcare", "PREFSH"],
    premiumContribution: ["Premium Contribution", "PREMC"],
    preTaxCancerPlan: ["Pre-tax Cancer Plan", "PRECAN"],
    garnishment: ["Garnishment", "GARN"],
    postTaxGroupLegalServices: [
        "Post Tax Group Legal Services",
        "LGLADV",
        "Post-Tax Group Legal Services Instruction",
    ],
    postTaxVision: ["VISION", "Post Tax Primary Vision Premium"],
    preTaxMedical: [
        "PREMED",
        "Pre Tax Medical",
        "Pre Tax Primary Medical Premium",
    ],
    preTaxVision: ["Pre Tax Primary Vision Premium", "PREVIS"],
    dentalInsurancePremium: ["Post Tax Primary Dental Premium", "DENTAL"],
    generalPostTaxDeduction: ["General Post Tax Deduction", "MISCON"],
    generalPreTaxDeduction: ["General Pre Tax Deduction", "PREMSC"],
    postTaxMedical: [
        "Post-Tax Medical",
        "POSTMD",
        "Post Tax Primary Medical Premium",
    ],
    postTaxDependentLifeInsPremium: ["Post Tax Dependent Life Ins Premium"],
    postTaxLongTermDisabilityPremium: ["Post-Tax Long Term Disability Premium"],
    preTaxMedicalFlexibleSpendingAccount: [
        "Pre-Tax Medical Flexible Spending Account",
    ],
    postTaxVoluntaryLifeSpousePremium: [
        "Post-Tax Voluntary Life - Spouse Premium",
    ],
    postTaxVoluntaryLifeEmployeePremium: [
        "Post Tax Voluntary Life- Employee Premium",
    ],
    postTaxPersonalAccidentInsPremium: [
        "Post Tax Personal Accident Ins Premium",
    ],
    postTaxOtherADDPremium: [
        "Post Tax Other AD+D Premium", "GSADD"
    ],
    postTaxPrimaryLifeInsPremium: [
        "Post Tax Primary Life Ins Premium", "LIFE"
    ],
    preTaxDependentCareFlexSpendingAmt: [
        "Pre-Tax Dependent Care Flex Spending Account", "PREFSV"
    ],
};
export const noDataPlaceholder = "—";
export const NO_RECENT_LEAVE_CHANGES_MESSAGE = "No recent changes";
export const CHANGE_ATTRIBUTE_NAME_MAP = {
    "newIntermittentAbsence": "New Int Abs",
    "newPeriodNbr": "New Period",
    "periodStatus": "Period Status",
    "periodEndDate": "Period End Date",
    "periodEndDt": "Period End Date",
    "lastDayWorked": "Last Day Worked",
    "rtwStatus": "RTW Status",
    "leaveStatus": "Leave Status",
    "rtwDate": "RTW Date",
    "rtwDt": "RTW Date",
    "rtwSchedule": "RTW Schedule",
    "statusReason": "Status Reason",
    "fitForDuty": "Fit for Duty",
    "leaveEndDate": "Leave End Date",
    "leaveEndDt": "Leave End Date",
};
